import { CalendarPlus, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ActionButton, EmptyState } from "../kit";

export const SCHEDULE_PATH = "/coach-portal/games/schedule";

/**
 * Issue #1316 — the board's `games-empty` state, shared by Team selection
 * (D309: with no game, the landing shows it) and Your games: "No games
 * scheduled yet / Schedule a game, then pick the team for it." and the one
 * gold action, Schedule a game (`games-new-empty`).
 */
export default function GamesEmpty() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col" style={{ gap: 14 }}>
      <EmptyState
        shape="portal"
        data-testid="games-empty"
        icon={<CalendarPlus size={26} strokeWidth={2} />}
        line="No games scheduled yet"
        prose="Schedule a game, then pick the team for it."
      />
      <ActionButton data-testid="games-new-empty" icon={<Plus size={18} strokeWidth={2.4} />} onClick={() => navigate(SCHEDULE_PATH)}>
        Schedule a game
      </ActionButton>
    </div>
  );
}
